// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3QuD6","savePackageButton":"ClientWallet_savePackageButton__3G6HR"};